import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MixpanelService } from '@core/services';
import { EllipsisTooltipComponent, OrderStatusComponent } from '@shared/components';
import { TooltipFocusHandlerDirective } from '@shared/directives/tooltip-focus-handler.directive';
import { AppRoutes } from '@shared/helpers';
import { DashboardOrdersColumnEnum } from 'src/app/features/dashboard/_core/enums';
import { DashboardOrder, DashboardTableColumn } from 'src/app/features/dashboard/_core/interfaces';

@Component({
    selector: '[app-my-orders-table-row]',
    standalone: true,
    imports: [EllipsisTooltipComponent, RouterModule, OrderStatusComponent, TooltipFocusHandlerDirective, DatePipe],
    templateUrl: './my-orders-table-row.component.html',
    styleUrls: ['./my-orders-table-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyOrdersTableRowComponent {
    readonly columns = input.required<DashboardTableColumn<DashboardOrdersColumnEnum>[]>();
    readonly order = input.required<DashboardOrder>();

    readonly orderAbstractRoute = computed(() => AppRoutes.routes().ORDERS_ABSTRACT_DETAILS(this.order().id));

    readonly dashboardColumnsEnum = DashboardOrdersColumnEnum;

    constructor(private mixpanelService: MixpanelService) {}

    logOrderNameClick() {
        this.mixpanelService.logEvent('dashboard-order-name-redirect', {
            orderId: this.order().id,
        });
    }
}
